import { createUseStyles } from "react-jss";
import { EuiStepsHorizontal, EuiStepsHorizontalProps } from "@elastic/eui";

const useStyles = createUseStyles({
  mySteps: {
    cursor: "none",
    marginBottom: "8px",
    "& .euiStepHorizontal": {
      cursor: "default !important",
    },
    "& button": {
      cursor: "default !important",
    },
    "& .euiToolTipAnchor": {
      cursor: "default !important",
    },
    marginTop: "0px",
    '& button[data-step-status="complete"] .euiStepHorizontal__number': {
      background: "#1c8ccc",
      border: "none",
      position: "relative",
      color: "#fff !important",
      "& *": {
        display: "none !important",
      },
      width: "20px",
      height: "20px",
      marginTop: "4px",
      "&::after": {
        content: '"\\2713"', // Unicode checkmark (✓)
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "var(--fs10)",
        color: "#fff",
      },
    },
    '& button[data-step-status="current"] .euiStepHorizontal__number': {
      background: "#1c8ccc",
      border: "none",
      color: "#fff !important",
      "& *": {
        display: "none !important",
      },
      boxShadow: "none",
      width: "20px",
      height: "20px",
      marginTop: "4px",
    },
    '& button[data-step-status="incomplete"] .euiStepHorizontal__number': {
      background: "transparent",
      border: "1px solid #1c8ccc",
      color: "#1c8ccc !important",
      "& *": {
        display: "none !important",
      },
      boxShadow: "none",
      width: "20px",
      height: "20px",
      marginTop: "4px",
    },
    '& button[data-step-status="complete"] + .euiStepHorizontal__line': {
      backgroundColor: "#1c8ccc",
    },
    '& button[data-step-status="complete"] + .euiStepHorizontal .euiStepHorizontal__line': {
      backgroundColor: "#1c8ccc",
    },
    "& .euiStepHorizontal__title": {
      fontSize: "var(--fs12)",
      fontWeight: "normal",
      margin: 0,
    },
    "& .euiStepHorizontal:hover .euiStepHorizontal__title": {
      textDecoration: "none !important",
    },
    '& button[data-step-status="complete"]::before': {
      backgroundColor: "#1c8ccc",
    },
    '& button[data-step-status="current"]::before': {
      backgroundColor: "#1c8ccc",
    },
    '& button[data-step-status="complete"]::after': {
      backgroundColor: "#1c8ccc",
    },
  },
});

const ProfileSteps = ({ currentStep, setCurrentStep, isEditMode }) => {
  const classes = useStyles();

  const horizontalSteps: EuiStepsHorizontalProps["steps"] = [
    {
      title: "Details",
      status: currentStep > 1 ? "complete" : currentStep === 1 ? "current" : "incomplete",
      onClick: () => {
        if (isEditMode) {
          setCurrentStep(1);
        }
      },
    },
    {
      title: "Resources",
      status: currentStep > 2 ? "complete" : currentStep === 2 ? "current" : "incomplete",
      onClick: () => {
        if (isEditMode) {
          setCurrentStep(2);
        }
      },
    },
    {
      title: "Alerts",
      status: currentStep > 3 ? "complete" : currentStep === 3 ? "current" : "incomplete",
      onClick: () => {
        if (isEditMode) {
          setCurrentStep(3);
        }
      },
    },
    {
      title: "Notifications",
      status: currentStep > 4 ? "complete" : currentStep === 4 ? "current" : "incomplete",
      onClick: () => {
        if (isEditMode) {
          setCurrentStep(4);
        }
      },
    },
  ];

  return (
    <div className={classes.mySteps}>
      <EuiStepsHorizontal steps={horizontalSteps} size="s" />
    </div>
  );
};

export default ProfileSteps;
